import { render, staticRenderFns } from "./Dell.vue?vue&type=template&id=74a6c5cd&scoped=true&"
import script from "./Dell.vue?vue&type=script&lang=js&"
export * from "./Dell.vue?vue&type=script&lang=js&"
import style0 from "./Dell.vue?vue&type=style&index=0&id=74a6c5cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a6c5cd",
  null
  
)

export default component.exports